<script>
    export let src = null;
    export let tenantKey = '';
    export let hasVideo;
    export let alt = '';
    export let fillContainer = false;
    export let animation = 'none';
    export let imgHeight;
</script>

<style>
    .image-container {
        position: relative;
        height: 100%;
        overflow: hidden;
        border-radius: .9rem;
    }
    .image {
        display: flex;
        justify-content: center;
        align-items: center;
        background: var(--no-media-color);
        width: 100%;
        height: 11.5rem;
        object-fit: cover;
        border-radius: .9rem;
    }

    .image--scale-animation {
        animation: scale-animation 5s infinite ease-in-out alternate;
    }

    @keyframes scale-animation {
        from { transform: scale(1); }
        to { transform: scale(1.2); }
    }

    .image .media-fallback {
        width: 4rem;
        height: 4rem;
    }

    .image--fill {
        width: 100%;
        height: 100%;
    }
    .video-icon {
        position: absolute;
        top: 0.5rem;
        right: 0.5rem;
        box-shadow: 0 0 16px 0 rgb(65 65 90 / 15%);
    }
    .adjustable-height {
        transition: height .5s ease;
    }
</style>

{#if (src)}

    <div class="image-container">

<!--        <picture class="image adjustable-height {animation === 'scale' ? 'image&#45;&#45;scale-animation' : '' } {fillContainer ? 'image&#45;&#45;fill' : ''}">-->
<!--            <source media="(min-width: 45em)" srcset="https://patico-qr-test.s3.eu-west-3.amazonaws.com/{tenantKey}/_media_files/_196/{src}" />-->
<!--            <source media="(min-width: 18em)" srcset="https://patico-qr-test.s3.eu-west-3.amazonaws.com/{tenantKey}/_media_files/_196/{src}" />-->
<!--            <source srcset="./images/fallback-image.svg" />-->
<!--            <img src="https://patico-qr-test.s3.eu-west-3.amazonaws.com/{tenantKey}/_media_files/_196/{src}"-->
<!--                 alt=""-->
<!--                 loading="lazy" />-->
<!--        </picture>-->

        <object class="image adjustable-height {animation === 'scale' ? 'image--scale-animation' : '' } {fillContainer ? 'image--fill' : ''}"
                data="https://patico-qr-test.s3.eu-west-3.amazonaws.com/{tenantKey}/_media_files/_196/{src}"
                style:height="{imgHeight}"
                loading="lazy"
                type="image/png">
            <img class="media-fallback adjustable-height"
                 src="./images/fallback-image.svg"
                 style:height="{imgHeight}"
                 loading="lazy"
                 alt={alt}>
        </object>

        {#if (hasVideo)}
            <img class="video-icon" src="./images/video.svg" loading="lazy"  alt="{alt}">
        {/if}
    </div>


{:else }

    <div class="image adjustable-height {fillContainer ? 'image--fill' : ''}" style:height="{imgHeight}">
        <img class="media-fallback"
             src="./images/fallback-image.svg"
             loading="lazy"
             alt={alt}>
    </div>

{/if}
